// src/encounter/lib/superseded-save.ts
// #690 (Andrew, 10 Oct 2026): a note save cancelled because a newer one replaced it rejects with an AbortError. That is
// "superseded", never a failure: no error banner, no retry, no dirty rollback. Its own module so the page's many test
// doubles of the save hook need not each provide it.

/** A save cancelled because a newer one replaced it — superseded, never a failure to show or retry. */
export function isSupersededSave(error: unknown): boolean {
  return error instanceof DOMException && error.name === 'AbortError';
}
